import { useMutation } from "@apollo/client";

import { AddGoalWithBeneficiaryMutation, AddGoalWithBeneficiaryMutationVariables } from "@ctypes";
import { ADD_GOAL_WITH_BENEFICIARY, USER } from "@graphql";

export const useAddGoalWithBeneficiary = () => {
  return useMutation<AddGoalWithBeneficiaryMutation, AddGoalWithBeneficiaryMutationVariables>(
    ADD_GOAL_WITH_BENEFICIARY,
    {
      refetchQueries: [{ query: USER }],
      awaitRefetchQueries: true,
    },
  );
};
